(function () {
  function getVariants(card) {
    if (card._cartRecommendationVariants) return card._cartRecommendationVariants;

    const data = card.querySelector('[data-cart-recommendation-variants]');
    if (!data) return [];

    try {
      card._cartRecommendationVariants = JSON.parse(data.textContent || '[]');
    } catch (error) {
      console.error(error);
      card._cartRecommendationVariants = [];
    }

    return card._cartRecommendationVariants;
  }

  function getSelectedVariant(card) {
    const selected = {};
    card.querySelectorAll('[data-cart-recommendation-option]').forEach(function (select) {
      if (select instanceof HTMLSelectElement) {
        selected[select.dataset.cartRecommendationOption] = select.value;
      }
    });

    return getVariants(card).find(function (variant) {
      return (
        (!selected['1'] || variant.option1 === selected['1']) &&
        (!selected['2'] || variant.option2 === selected['2']) &&
        (!selected['3'] || variant.option3 === selected['3'])
      );
    });
  }

  function updateCardVariant(card) {
    const variant = getSelectedVariant(card);
    const addButton = card.querySelector('[data-cart-recommendation-add]');
    const price = card.querySelector('[data-cart-recommendation-current-price]');
    const comparePrice = card.querySelector('[data-cart-recommendation-compare-price]');
    const priceRow = card.querySelector('.cart-recommendation-card__price');
    const image = card.querySelector('.cart-recommendation-card__image');

    if (!variant) {
      card.dataset.salesVariantId = '';
      if (addButton instanceof HTMLButtonElement) {
        addButton.disabled = true;
        addButton.textContent = addButton.dataset.cartRecommendationOutOfStockText || 'Out of Stock';
      }
      return;
    }

    card.dataset.salesVariantId = String(variant.id);

    if (price) price.textContent = variant.price || '';

    if (comparePrice) {
      comparePrice.textContent = variant.comparePrice || '';
      comparePrice.hidden = !variant.comparePrice;
    }

    if (priceRow) {
      priceRow.classList.toggle('cart-recommendation-card__price--sale', Boolean(variant.comparePrice));
    }

    if (image instanceof HTMLImageElement && variant.image) {
      image.src = variant.image;
      image.removeAttribute('srcset');
      if (variant.imageAlt) image.alt = variant.imageAlt;
    }

    if (addButton instanceof HTMLButtonElement) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'ADD TO CART' : addButton.dataset.cartRecommendationOutOfStockText || 'Out of Stock';
    }
  }

  function scrollRecommendations(control, direction) {
    const section = control.closest('.cart-drawer__best-sellers');
    const scroller = section ? section.querySelector('[data-cart-recommendations-scroll]') : null;
    if (!(scroller instanceof HTMLElement)) return;

    const card = scroller.querySelector('.cart-drawer__best-seller-card');
    const cardWidth = card instanceof HTMLElement ? card.getBoundingClientRect().width : 212;
    const styles = window.getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

    scroller.scrollBy({
      left: direction * (cardWidth + gap),
      behavior: 'smooth'
    });

    window.requestAnimationFrame(function () {
      updateRecommendationControls(section);
    });
  }

  function getRecommendationSignature(section) {
    return Array.prototype.map
      .call(section.querySelectorAll('[data-cart-recommendation-card], .cart-drawer__best-seller-card'), function (card) {
        return card.getAttribute('data-sales-product-id') || card.textContent.trim();
      })
      .join('|');
  }

  function updateRecommendationControls(section) {
    const scroller = section ? section.querySelector('[data-cart-recommendations-scroll]') : null;
    const previous = section ? section.querySelector('[data-cart-recommendations-prev]') : null;
    const next = section ? section.querySelector('[data-cart-recommendations-next]') : null;
    if (!(section instanceof HTMLElement) || !(scroller instanceof HTMLElement)) return;
    if (!(previous instanceof HTMLElement) || !(next instanceof HTMLElement)) return;

    const signature = getRecommendationSignature(section);
    const previousSignature = section._cartRecommendationsSignature;
    const signatureChanged = Boolean(previousSignature && previousSignature !== signature);
    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    const currentScrollLeft = scroller.scrollLeft;
    const scrollLeft = signatureChanged ? 0 : currentScrollLeft;
    const cards = scroller.querySelectorAll('.cart-drawer__best-seller-card');
    const canScroll = cards.length > 1 && maxScrollLeft > 1;
    const hidePrevious = !canScroll || scrollLeft <= 1;
    const hideNext = !canScroll || scrollLeft >= maxScrollLeft - 1;

    if (signatureChanged && currentScrollLeft !== 0) scroller.scrollLeft = 0;
    if (previousSignature !== signature) section._cartRecommendationsSignature = signature;
    if (previous.hidden !== hidePrevious) previous.hidden = hidePrevious;
    if (next.hidden !== hideNext) next.hidden = hideNext;
  }

  let recommendationSyncFrame = 0;

  function getOpenCartDrawer() {
    return Array.prototype.find.call(document.querySelectorAll('cart-drawer-component'), function (drawer) {
      const dialog = drawer.querySelector('dialog[ref="dialog"]');
      return dialog instanceof HTMLDialogElement && dialog.open;
    });
  }

  function scheduleRecommendationControlsSync() {
    if (!getOpenCartDrawer()) return;
    if (recommendationSyncFrame) return;

    recommendationSyncFrame = window.requestAnimationFrame(function () {
      recommendationSyncFrame = 0;
      const drawer = getOpenCartDrawer();
      if (drawer) initRecommendationControls(drawer);
    });
  }

  function initRecommendationControls(root) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const sections = [];

    if (scope instanceof Element && scope.matches('.cart-drawer__best-sellers')) {
      sections.push(scope);
    }

    scope.querySelectorAll('.cart-drawer__best-sellers').forEach(function (section) {
      sections.push(section);
    });

    sections.forEach(function (section) {
      const scroller = section.querySelector('[data-cart-recommendations-scroll]');
      if (!(scroller instanceof HTMLElement)) return;

      if (!scroller._cartRecommendationsControlsInit) {
        scroller._cartRecommendationsControlsInit = true;
        scroller.addEventListener(
          'scroll',
          function () {
            scheduleRecommendationControlsSync();
          },
          { passive: true }
        );
      }

      updateRecommendationControls(section);
    });
  }

  function getRecommendationSelect(target) {
    const select = target instanceof Element ? target.closest('[data-cart-recommendation-option]') : null;
    return select instanceof HTMLSelectElement ? select : null;
  }

  document.addEventListener('change', function (event) {
    const select = getRecommendationSelect(event.target);
    if (!select) return;

    const card = select.closest('[data-cart-recommendation-card]');
    if (card instanceof HTMLElement) {
      updateCardVariant(card);
    }
  });

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const previous = target.closest('[data-cart-recommendations-prev]');
    if (previous instanceof HTMLElement) {
      event.preventDefault();
      scrollRecommendations(previous, -1);
      return;
    }

    const next = target.closest('[data-cart-recommendations-next]');
    if (next instanceof HTMLElement) {
      event.preventDefault();
      scrollRecommendations(next, 1);
    }
  });

  document.addEventListener('cart:update', function () {
    scheduleRecommendationControlsSync();
  });

  window.addEventListener('resize', function () {
    scheduleRecommendationControlsSync();
  });

  const observer = new MutationObserver(function () {
    scheduleRecommendationControlsSync();
  });

  function init() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
    }

    scheduleRecommendationControlsSync();
  }

  document.addEventListener(
    'dialog:open',
    function (event) {
      if (event.target instanceof Element && event.target.matches('cart-drawer-component')) {
        scheduleRecommendationControlsSync();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
